'use client'

import React, { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import FounderSectionSchema, { FounderSectionProps, FounderSectionDefaultValues } from './schema'
import FounderSection from '@/components/RevampedLanding/FounderSection'

export function FounderSectionWidget(props: FounderSectionProps) {
  const { founderSection } = props

  return <FounderSection founderSectionData={props} />
}

export default createWidget<FounderSectionProps>({
  formType: FounderSectionSchema,
  render(props): JSX.Element {
    return <FounderSectionWidget {...props} />
  },
  id: 'Landing.Page.FounderSection',
  name: 'Landing Founder Section',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: FounderSectionDefaultValues,
})
